import { DataSourceCategory } from './../../enums/data-source-category';
import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-data-source-category-view',
    templateUrl: './data-source-category-view.component.html',
    styleUrls: ['./data-source-category-view.component.scss']
})
export class DataSourceCategoryViewComponent implements OnInit {
    _dataSourceCategories: DataSourceCategory[] = [];

    get dataSourceCategories(): DataSourceCategory[] {
        return this._dataSourceCategories;
    }

    @Input()
    set dataSourceCategories(value: DataSourceCategory[]) {
        this._dataSourceCategories = value;
        this.initDataSourceCategories();
    }

    constructor() {}

    get isCheckedCity(): boolean {
        return this.dataSourceCategories.includes(DataSourceCategory.CITY);
    }

    get isCheckedCounty(): boolean {
        return this.dataSourceCategories.includes(DataSourceCategory.COUNTY);
    }

    get isCheckedState(): boolean {
        return this.dataSourceCategories.includes(DataSourceCategory.STATE);
    }

    ngOnInit() {
        this.initDataSourceCategories();
    }

    initDataSourceCategories() {
        if (_.isEmpty(this.dataSourceCategories)) {
            this.dataSourceCategories = [DataSourceCategory.CITY, DataSourceCategory.COUNTY, DataSourceCategory.STATE];
        }
    }
}
